const Shoutout = () => {
    return (
        <div className=" py-10">
            <h3>Huge Shoutout to <a href="https://gola.io/" target="_blank" rel="noreferrer" className="text-pink" >gola design</a> for the inspo</h3>
        </div>
    )
}

export default Shoutout